export const UNAUTHORISED = 'UNAUTHORISED'
export const UNKNOWN = 'UNKNOWN'
export const BAD_REQUEST = 'Bad request'
export const UNPROCESSABLE_ENTITY = 'Unprocessable entity'
export const NO_CONTENT = 'No content'
